import {isLbsyun} from '../App/util';
import style from './index.less';
export default ({isWap = false}: {registerUcLink: string; subuserLoginLink: string; isWap?: boolean}) => {
    const divideClass = isWap ? style['divide-line-wap'] : style['divide-line'];
    const forgetUrl = isWap ? 'https://aq.baidu.com/new/secure/password/user' : 'http://aq.baidu.com/new/#/findpwd';
    const retrieveUrl = isWap ? '/retrieve-mobile' : '/retrieve';
    return isLbsyun() ? null : (
        <div className={style.container}>
            <a className={style.link} href={forgetUrl} target="_blank" rel="noreferrer">
                忘记密码
            </a>
            <div className={divideClass}></div>
            <a className={style.link} target="_blank" rel="noreferrer" href={retrieveUrl}>
                忘记账号
            </a>
        </div>
    );
};
